The collection of possible responses.

- `FreeText` must not contain any elements.
- `MultiSelect` must contain at least two elements.
- `SingleSelect` must contain at least two elements.
